import React, { forwardRef, useEffect } from 'react';
import pt from 'prop-types';
import { combine } from '../../helpers/styles';
import * as styles from './styles.module.scss';

const Container = forwardRef(
  (
    {
      children,
      fluid,
      fullWidth,
      noGap,
      small,
      hasWhiteBg,
      innerClass,
      className,
      id,
      ...props
    },
    ref
  ) => {
    return small ? (
      <div
        className={combine(
          styles.container,
          fullWidth && styles.fullWidth,
          fluid && styles.fluid,
          noGap && styles.noGap,
          small && styles.small,
          className
        )}
        id={id ? id : null}
        {...props}
        ref={ref}
      >
        <div className={combine(hasWhiteBg && styles.whiteBg, innerClass)}>
          {children}
        </div>
      </div>
    ) : (
      <div
        className={combine(
          styles.container,
          fullWidth && styles.fullWidth,
          fluid && styles.fluid,
          noGap && styles.noGap,
          className
        )}
        id={id ? id : null}
        {...props}
        ref={ref}
      >
        {children}
      </div>
    );
  }
);

Container.propTypes = {
  children: pt.node.isRequired,
  className: pt.string,
  innerClass: pt.string,
  fluid: pt.bool,
  small: pt.bool,
  hasWhiteBg: pt.bool,
  noGap: pt.bool,
  fullWidth: pt.bool,
  id: pt.string,
};

Container.defaultProps = {
  className: '',
  innerClass: '',
  fluid: false,
  noGap: false,
  small: false,
  fullWidth: false,
  hasWhiteBg: false,
  id: '',
};

export default Container;
